import { Injectable, Type } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { MgDialogData, MgModalContent } from '../shared/dialog.interface';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { DialogComponent } from '../shared/dialog';
import { BaseComponent } from '../shared/base.component';
// import { MgxBreakPointQueries } from '../shared/mgx.breakpoints';

@Injectable()
export class DialogService extends BaseComponent {
  isMobile: Observable<BreakpointState> = this.breakpointObserver.observe([
    'screen and (min-width: 768px)' as any,
  ]);
  dialogRef!: MatDialogRef<any>;
  closed$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog,
    public base: BaseComponent
  ) {
    super();
  }

  private defaultDialogConfig: MatDialogConfig = {
    autoFocus: true,
    panelClass: 'custom-dialog-container',
    hasBackdrop: true,
    maxWidth: '100vw',
    maxHeight: '100vh',
    closeOnNavigation: false,
  };

  public open<T = MgDialogData>(
    content: MgModalContent,
    dialogConfig?: MatDialogConfig<T>
  ): Observable<any> {
    this.closed$ = new Subject<boolean>();

    const config: MatDialogConfig<any> = {
      ...this.defaultDialogConfig,
      ...dialogConfig,
    };

    config.data = {
      ...config.data,
      content,
      params:
        dialogConfig && dialogConfig.data
          ? { ...dialogConfig.data }
          : undefined,
    };

    this.dialogRef = this.dialog.open(DialogComponent, config);

    this.dialogRef.beforeClosed().subscribe(() => {
      this.closed$.next(true);
      this.closed$.complete();
    });

    this.isMobile.subscribe((size) => {
      if (size.matches) {
        this.dialogRef.updateSize();
      } else {
        this.dialogRef.updateSize('100%', '100%');
      }
    });

    this.closed$.next(false);

    // this.addToTransactionKey({
    //   modal_window_name: content['name'],
    //   page_view: false,
    //   event: 'dataLayerPush'
    // });

    return this.dialogRef.afterClosed();
  }

  public close() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  public hideCloseButton(): void {
    if (this.dialogRef) {
      this.dialogRef.removePanelClass('custom-dialog-container');
      this.dialogRef.addPanelClass('custom-dialog-without-close');
    }
  }

  public showCloseButton(): void {
    if (this.dialogRef) {
      this.dialogRef.removePanelClass('custom-dialog-without-close');
      this.dialogRef.addPanelClass('custom-dialog-container');
    }
  }
}
